/**
 * Identifies the running bundle. Set at build time (e.g. Cloudflare: REACT_APP_BUILD_ID)
 * or override locally with REACT_APP_VERSION_ID in `.env`.
 */
export const APP_VERSION_ID =
  process.env.REACT_APP_VERSION_ID ||
  process.env.REACT_APP_BUILD_ID ||
  "local";

export function logAppVersion() {
  console.log("[BottleCycler] App version id:", APP_VERSION_ID);
}
